import PartnerAudienceDetails from 'scenes/SpendAdjustments/components/SpendAdjustmentDetails/SpendAdjustmentDetails';

export { SpendAdjustmentDetailsRouteElement } from './SpendAdjustmentDetailsRouteElement';

export default PartnerAudienceDetails;
